"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pager = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/icon");
const icon_names_1 = require("@/components/common/icon/icon-names");
const surface_styles_1 = require("@/components/common/surface/surface.styles");
require("@/components/common/text/semantics/text-block");
const constants_1 = require("@/constants");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/** 이전·다음 링크 카드로 이동한다. 내비게이션 이름(aria-label)과 링크 문구는 감싸는 시멘틱 컴포넌트가 정한다. */
let Pager = class Pager extends lit_1.LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'navigation');
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderLink('prev', this.previous)} ${this.renderLink('next', this.next)}
    `;
    }
    renderLink(rel, link) {
        if (!link)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <a rel=${rel} href=${link.href}>
        <mm-icon
          name=${rel === 'prev' ? icon_names_1.ICON_NAMES.PREVIOUS : icon_names_1.ICON_NAMES.NEXT}
          aria-hidden="true"
        ></mm-icon>
        <mm-text-block
          level="3"
          heading=${link.heading}
          description=${link.description}
        ></mm-text-block>
      </a>
    `;
    }
};
Pager.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: flex;
        justify-content: space-between;
        gap: var(--space-4);
        padding-top: var(--space-section);
      }

      a {
        ${surface_styles_1.surfaceBaseStyles};
        --surface-shadow: var(--material-elevated-shadow);
        --lift: none;

        flex: 1;
        gap: var(--space-3);
        transform: var(--lift);
        transition: box-shadow var(--transition-duration) var(--transition-easing),
          transform var(--transition-duration) var(--transition-easing);
      }

      a:hover {
        --lift: var(--interaction-hover-lift);
      }

      a[rel='next'] {
        align-items: flex-end;
        text-align: right;
      }

      a[rel='next'] mm-text-block {
        align-items: flex-end;
      }

      @media ${constants_1.MEDIA.compact} {
        :host {
          flex-direction: column-reverse;
        }
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], Pager.prototype, "previous", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], Pager.prototype, "next", void 0);
Pager = __decorate([
    (0, decorators_js_1.customElement)('mm-pager')
], Pager);
exports.Pager = Pager;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYWdlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBb0Q7QUFDcEQscURBQTJEO0FBRTNELG9DQUFpQztBQUNqQyxvRUFBZ0U7QUFDaEUsK0VBQThFO0FBQzlFLHlEQUFzRDtBQUN0RCwyQ0FBbUM7QUFDbkMsK0RBQXlEO0FBUXpELHlFQUF5RTtBQUVsRSxJQUFNLEtBQUssR0FBWCxNQUFNLEtBQU0sU0FBUSxnQkFBVTtJQThDbkMsaUJBQWlCO1FBQ2YsS0FBSyxDQUFDLGlCQUFpQixFQUFFLENBQUE7UUFDekIsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsWUFBWSxDQUFDLENBQUE7SUFDekMsQ0FBQztJQUVELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBO1FBQ1AsSUFBSSxDQUFDLFVBQVUsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDLFFBQVEsQ0FBQyxJQUFJLElBQUksQ0FBQyxVQUFVLENBQUMsTUFBTSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUM7S0FDL0UsQ0FBQTtJQUNILENBQUM7SUFFTyxVQUFVLENBQUMsR0FBb0IsRUFBRSxJQUFnQjtRQUN2RCxJQUFJLENBQUMsSUFBSTtZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRXpCLE9BQU8sSUFBQSxVQUFJLEVBQUE7ZUFDQSxHQUFHLFNBQVMsSUFBSSxDQUFDLElBQUk7O2lCQUVuQixHQUFHLEtBQUssTUFBTSxDQUFDLENBQUMsQ0FBQyx1QkFBVSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsdUJBQVUsQ0FBQyxJQUFJOzs7OztvQkFLbkQsSUFBSSxDQUFDLE9BQU87d0JBQ1IsSUFBSSxDQUFDLFdBQVc7OztLQUduQyxDQUFBO0lBQ0gsQ0FBQzs7QUF4RU0sWUFBTSxHQUFHO0lBQ2QsMkJBQVc7SUFDWCxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7O1VBU0csa0NBQWlCOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7ZUF3QlosaUJBQUssQ0FBQyxPQUFPOzs7OztLQUt2QjtDQUNGLENBQUE7QUFDK0I7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDO3VDQUFxQjtBQUNwQjtJQUEvQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLENBQUM7bUNBQWlCO0FBNUNyQyxLQUFLO0lBRGpCLElBQUEsNkJBQWEsRUFBQyxVQUFVLENBQUM7R0FDYixLQUFLLENBMEVqQjtBQTFFWSxzQkFBSyJ9